export const SHARED_PAYMENT_LINKS_EVENTS = {
  PAYMENT_METHODS_SAVED: 'Payment Link Payment Methods Saved',
};

export const SHARED_PAYMENT_LINKS_EVENTS_PARAMS = {
  SELECTED_METHODS_COUNT: 'selected_methods_count',
  SELECTED_METHODS: 'selected_methods',
  HAS_CARD_METHODS: 'has_card_method',
  CARD_INTEGRATION_ID: 'card_integration_id',
};

export const SHARED_PAYMENT_LINKS_EVENTS_VALUES = {
  CARD: 'card',
};
